// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container, Form } from 'react-bootstrap';
import moment from 'moment';

// Services & Helpers
import CourseCheckerService from 'services/CourseCheckerService';
import GlobalStateService from 'services/GlobalStateService';

// Components
import Loader     from 'components/common/Loader';
import DatePicker from 'components/common/DatePicker';
import PageHeader from 'components/common/PageHeader';

//-------------------------------------------------------------------------------------------------------------------

class CourseCheckerPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            results: null,
            fileName: null,
            isUploading: false,
            startDate: moment().add(1, 'weeks').startOf('isoWeek').toDate(),
            endDate: moment().add(1, 'weeks').startOf('isoWeek').add(6, 'days').toDate()
        }
    }

    componentDidMount() {
        GlobalStateService.setValues({
            area: 'course-checker'
        });
    }

    async upload(field) {
        if (field.files.length > 0) {
            const file = field.files[0];
            this.setState({ isUploading: true });
            const results = await CourseCheckerService.upload(file, this.state.startDate, this.state.endDate);
            field.value = '';
            this.setState({
                fileName: file.name,
                isUploading: false,
                results
            });
        }
    }

    //--------------------------------------------------------------------------------------------------------------------
    //  Render
    //--------------------------------------------------------------------------------------------------------------------

    render() {
        const {
            isLoading
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (
            <div className="page course-checker-page">
        		<PageHeader>
                    <h1>Course Checker</h1>
                </PageHeader>
                
		        <main>

			        <Container>
				
				        <section>

					        {this.renderInner()}

				        </section>

			        </Container>

		        </main>

            </div>
        );
    }

    renderInner() {
        const {
            fileName,
            startDate,
            endDate,
            isUploading,
            results
        } = this.state;

        return (<>

            <h2>1. Select date range</h2>

            <Form.Group className="mb-3">
                <Form.Label>From</Form.Label>
                <DatePicker
                    className="form-control"
                    selected={startDate}
                    onChange={value => this.setState({ startDate: value })}
                    readOnly={!!isUploading || !!results}
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>To</Form.Label>
                <DatePicker
                    className="form-control"
                    selected={endDate}
                    onChange={value => this.setState({ endDate: value })}
                    readOnly={!!isUploading || !!results}
                />
            </Form.Group>

            <hr />

            <h2>2. Upload an Excel file</h2>
            <p>The file must have a single column labelled <strong>LMS ID</strong>.</p>
            <label className="btn btn-secondary btn-block upload-button mt-2">
                {isUploading ? <>
                    <Loader isInline />{' '}Uploading...
                </> : <>
                    {fileName ? <>
                        <span className="fa-solid fa-check"></span>{' '}{fileName}
                    </> : <>
                        <span className="fa-solid fa-upload"></span>{' '}Upload
                        <input
                            type="file"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            onChange={e => this.upload(e.target)}
                        />
                    </>}
                </>}
            </label>
            
            {results && <>
                <hr />

                <h2>3. Results</h2>

                <div className="sticky-table-container scrolling">
                    <table className="table table-bordered sticky-table">
                        <thead>
                            <tr>
                                <th>LMS ID</th>
                                <th>In list provided?</th>
                                <th>In system?</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {results.map((row, index) =>
                                <tr key={index}>
                                    <td>
                                        <div className={row.isInList && row.isInSystem ? 'text-good' : 'text-bad'}>
                                            {row.lmsid}
                                        </div>
                                    </td>
                                    <td>
                                        {row.isInList ?
                                            <div className="text-good"><span className="fa-solid fa-check" />{' '}Yes</div> :
                                            <div className="text-bad"><span className="fa-solid fa-times" />{' '}NO</div>
                                        }
                                    </td>
                                    <td>
                                        {row.isInSystem ?
                                            <div className="text-good"><span className="fa-solid fa-check" />{' '}Yes</div> :
                                            <div className="text-bad"><span className="fa-solid fa-times" />{' '}NO</div>
                                        }
                                    </td>
                                    <td>
                                        {row.date ? moment(row.date).format('DD/MM/YYYY') : ''}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                
            </>}
        </>);
    }

    renderResults() {
        const {
            results
        } = this.state;

        return (<>
            
            <hr />

            {this.renderResults()}

        </>);
    }
}

export default withRouter(CourseCheckerPage);